import React, { useState } from 'react';
import { trackFormSubmission } from '../utils/googleAds';
import './contact-form41.css';

const ContactForm = (props) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const [status, setStatus] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);

    // Track form submission for Google Ads
    trackFormSubmission('contact');

    // Show success message immediately after clicking Submit
    setShowModal(true);
    setStatus('Thank you for contacting us! We will get back to you soon.');

    fetch('https://formsubmit.co/ajax/admin@dataflows.com.au', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleModalClose = () => {
    setShowModal(false);
    window.scrollTo(0, 0); // Scroll to the top of the page
    setTimeout(() => {
      window.location.reload(); // Reload the page
    }, 500);
  };

  return (
    <div className="contact-form-container" id={props.contactForm41Id}>
      <div className="contact-form-card">
        <div className="contact-form-header">
          <h2 className="contact-form-title">Contact Us</h2>
          <p className="contact-form-description">
            We'd love to hear from you! Fill out the form below and we'll get back to you as soon as possible.
          </p>
        </div>
        
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label" htmlFor="name">Full Name</label>
            <div className="input-container">
              <input
                type="text"
                id="name"
                name="name"
                className="form-input"
                placeholder="John Doe"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <div className="input-focus-effect"></div>
            </div>
          </div>
          
          <div className="form-group">
            <label className="form-label" htmlFor="email">Email Address</label>
            <div className="input-container">
              <input
                type="email"
                id="email"
                name="email"
                className="form-input"
                placeholder="your@email.com"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <div className="input-focus-effect"></div>
            </div>
          </div>
          
          <div className="form-group">
            <label className="form-label" htmlFor="message">Your Message</label>
            <div className="textarea-container">
              <textarea
                id="message"
                name="message"
                className="form-textarea"
                placeholder="How can we help you?"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
              ></textarea>
              <div className="input-focus-effect"></div>
            </div>
          </div>
          
          <button type="submit" className="submit-button">
            <span className="button-text">Send Message</span>
            <span className="button-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
                <path d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z" />
              </svg>
            </span>
          </button>
        </form>
      </div>

      {showModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <div className="modal-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="48" height="48">
                <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12Zm13.36-1.814a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z" clip-rule="evenodd" />
              </svg>
            </div>
            <h2 className="modal-title">Thank You!</h2>
            <p className="modal-message">{status}</p>
            <button onClick={handleModalClose} className="modal-button">
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactForm;

